@for (ranking of rankings; track ranking) {
  <mat-card class="mat-elevation-z4 break-inside-avoid p-4 text-center print:border-0 print:bg-steel-5" appearance="outlined">
    <div class="font0-bold -mx-4 -mt-4 uppercase" [ngClass]="getRankingColours(ranking)">
      {{ 'marketReports.rankings.title' | transloco: { rank: ranking.rankPosition } }}
    </div>
    <div class="my-5 text-4xl text-steel-70">{{ ranking.rankValue }}</div>
    <div class="font-bold">{{ 'rankings.type.' + ranking.rankingType | lowercase | transloco }}</div>
    <div class="text-steel-70">{{ ranking.locationName }}</div>
  </mat-card>
}
